import React from 'react';
import './FAQ.css'; // for custom styles if needed
import { Accordion } from 'react-bootstrap';

const questions = [
  "What is Eleget AI for customer service?",
  "How does Eleget AI for customer service work?",
  "How does Eleget AI improve response times and resolution rates?",
  "Is Eleget AI for customer service secure and compliant with data privacy regulations?",
  "How is Eleget AI customer service priced? Is there a free trial available?",
  "What kind of support does Eleget offer for AI customer service?",
  "How does Eleget’s AI customer service perform?",
];

function FAQ() {
  return (
    <div className="faq-wrapper py-5 px-3 text-center bg-light">
      <h3 className="fw-bold mb-4">AI customer service FAQs</h3>

      <div className="mx-auto" style={{ maxWidth: '700px' }}>
        <Accordion defaultActiveKey="">
          {questions.map((q, i) => (
            <Accordion.Item eventKey={i.toString()} key={i} className="mb-2 rounded shadow-sm">
              <Accordion.Header>{q}</Accordion.Header>
              <Accordion.Body>
                This is a sample answer to the question: <strong>{q}</strong>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>

      <div className="mt-5">
        <h2 className="fw-bold mb-3">Ready to unleash the power of<br />AI customer service?</h2>
        <button className="btn btn-primary px-4 py-2">
          Contact sales
        </button>
      </div>
    </div>
  );
}

export default FAQ;
